import styled from 'styled-components'

// Matches AudienceTargeting/Interests' category-card icon tile — same
// 2rem square, radius and accent tokens — so the two guide-style panels in
// the offsite briefing flow read as one visual family.
export const GuideTypeIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  border-radius: var(--sl-radius-2);
  background: var(--sl-bg-accent);
  color: var(--sl-fg-accent);
`

export const GuideTypeGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--sl-space-4);
  margin-top: var(--sl-space-3);

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`

export const GuideType = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--sl-space-3);
  min-width: 0;
`

export const GuideTypeCopy = styled.div`
  min-width: 0;
  flex: 1;
`

export const GuideTypeTitle = styled.h4`
  margin: 0 0 var(--sl-space-2);
  font: var(--sl-text-emphasis-font);
  color: var(--sl-fg-base);
`

export const GuideList = styled.ul`
  margin: 0;
  padding-left: 1.1rem;
  display: flex;
  flex-direction: column;
  gap: var(--sl-space-1);
  font: var(--sl-text-caption-1-font);
  color: var(--sl-fg-base-soft);

  li::marker {
    color: var(--sl-fg-base-soft);
  }
`

export const GuideIntro = styled.p`
  color: var(--sl-fg-base-soft);
  font: var(--sl-text-caption-1-font);
  margin: 0;
`
